import { Avatar, Card, Progress, Tag } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { getTargetString } from "../../helpers/targetHelpers";

function ObjectiveCard(props) {
  function GetDate(date) {
    let newDate = date.split("T");
    let parts = newDate[0].split("-");
    let newdate = new Date(parts[0], parts[1] - 1, parts[2]) + " ";

    let new_Date = newdate.split(" ");
    let month = new_Date[1];
    let dateOnly = new_Date[2];
    let year = new_Date[3];

    let targetdate = month + " " + dateOnly + " " + year;
    return targetdate;
  }

  return (
    <div className="max-w-5xl mb-6">
      <Link to={`/top-plans/${props.plan?.planId}`}>
        <Card
          style={{
            borderColor: "#e5e7eb",
            cursor: "pointer",
          }}
        >
          <div className="flex justify-between w-full items-center">
            <div>
              <div className="flex items-center mb-1">
                <Tag color="blue">{props.plan?.planGroup}</Tag>
                <div className="text-xs text-gray-400">
                  {props.plan?.targetDate
                    ? GetDate(props.plan?.targetDate)
                    : ""}
                </div>
              </div>
              <div className="flex items-center">
                {props.plan?.title}
                {(props.plan?.finalized === 1 || props.plan?.finalized === "1" || props.plan?.finalized === true) && (
                  <CheckCircleFilled 
                    style={{ 
                      color: '#90EE90', 
                      marginLeft: '8px', 
                      fontSize: '16px' 
                    }} 
                    title="Plan Finalized"
                  />
                )}
                {" - "}
                {getTargetString(
                  props.plan?.target,
                  props.plan?.scale?.scaleName,
                  props.plan?.scale?.scaleUnitAbbreviation
                )}
              </div>
            </div>
            <div>
              {props.plan?.assignedTo?.imageUrl ? (
                <Avatar
                  className="cursor-pointer"
                  src={props.plan?.assignedTo?.imageUrl}
                />
              ) : (
                <Avatar>
                  {props.plan?.assignedTo?.firstName?.charAt(0).toUpperCase()}
                </Avatar>
              )}
            </div>
          </div>
          <Progress
            strokeColor={{
              "0%": "#108ee9",
              "100%": "#87d068",
            }}
            percent={props.plan?.performance}
          />
        </Card>
      </Link>
    </div>
  );
}

export default ObjectiveCard;
